import WaitingWidget from "../elements/spinner/WaitingWidget";

interface PrepareProps { }

const Prepare: React.FC<PrepareProps> = () => {
  return (
    <WaitingWidget />
  )
}

export default Prepare;